import { render, staticRenderFns } from "./ComponentTextResume.vue?vue&type=template&id=51d7e679&"
import script from "./ComponentTextResume.vue?vue&type=script&lang=js&"
export * from "./ComponentTextResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports